module.exports = __webpack_public_path__ + "img/life.f502922f.jpg";